import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const ServicesSection = () => {
  const services = [
    {
      icon: "📱",
      title: "Bespoke Design",
      description: "Bespoke designs tailored to your brand.",
    },
    {
      icon: "💻",
      title: "Custom Web Development",
      description: "Powerful web applications built with modern frameworks.",
    },
    {
      icon: "🌐",
      title: "Website Deployment",
      description: "Seamless deployment and hosting solutions.",
    },
    {
      icon: "⚙️",
      title: "Maintenance & Support",
      description: "Ongoing support and maintenance services.",
    },
    {
      icon: "🔗",
      title: "API Integration  ",
      description: "Ongoing support and maintenance services.",
    },
    {
      icon: "☁️",
      title: "Cloud Hosting",
      description: "Ongoing support and maintenance services.",
    },
    {
      icon: "🧪",
      title: "Testing ",
      description: "Ongoing support and maintenance services.",
    },
    {
      icon: "🚀",
      title: "  Deployment ",
      description: "Ongoing support and maintenance services.",
    },
  ];

  const [index, setIndex] = useState(0);

  const visibleCards = () => {
    if (window.innerWidth >= 1024) return 3;
    if (window.innerWidth >= 640) return 2;
    return 1;
  };

  const next = () => {
    const maxIndex = services.length - visibleCards();
    setIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
  };

  const prev = () => {
    const maxIndex = services.length - visibleCards();
    setIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
  };

  return (
    <section id="services"className="py-20 bg-gray-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-orange-500 font-semibold mb-2">Our Services</h2>
        <h2 className="text-4xl font-bold mb-12">
          We're good at these areas to work
        </h2>

        <div className="relative">
          <div
            className="flex transition-transform duration-500"
            style={{
              transform: `translateX(-${index * (100 / visibleCards())}%)`,
            }}
          >
            {services.map((service, i) => (
              <div key={i} className="w-full sm:w-1/2 lg:w-1/3 px-3 shrink-0">
                <div className="bg-white p-8 rounded-lg shadow h-full">
                  <div className="text-5xl mb-4">{service.icon}</div>
                  <h3 className="text-xl font-bold mb-3">{service.title}</h3>
                  <p className="text-gray-600">{service.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Controls */}
          <button
            onClick={prev}
            className="absolute left-0 top-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow"
          >
            <ChevronLeft />
          </button>

          <button
            onClick={next}
            className="absolute right-0 top-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow"
          >
            <ChevronRight />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
